// extracted by mini-css-extract-plugin
export default {"tabs_box":"index_tabs_box_b6mKn","br":"index_br_DC9wF","shadow":"index_shadow_-M5Mm","tabs":"index_tabs_ZEWgd"};